import "babel-polyfill";
import fetch from "isomorphic-fetch";

export const SELECT_CATEGORY = "SELECT_CATEGORY";
export const REQUEST_MOVIES = "REQUEST_MOVIES";
export const RECEIVE_MOVIES = "RECEIVE_MOVIES";
export const INVALIDATE_CATEGORY = "INVALIDATE_CATEGORY";
export const SELECT_MOVIE_YEAR = "SELECT_MOVIE_YEAR";
export const SELECT_YEAR = "SELECT_YEAR";
export const RECEIVE_MOVIES_BY_IDS = "RECEIVE_MOVIES_BY_IDS";
export const INVALIDATE_NEWS = "INVALIDATE_NEWS";
export const REQUEST_NEWS = "REQUEST_NEWS";
export const RECEIVE_NEWS = "RECEIVE_NEWS";
export const SELECT_FESTIVAL_CITY = "SELECT_FESTIVAL_CITY";
export const INVALIDATE_FESTIVAL_CITY = "INVALIDATE_FESTIVAL_CITY";
export const REQUEST_FESTIVAL_CITY = "REQUEST_FESTIVAL_CITY";
export const RECEIVE_FESTIVAL_CITY = "RECEIVE_FESTIVAL_CITY";
// export const SERVER_BASE_URL = 'http://tspot.net/admin'
// export const CLIENT_BASE_URL = 'http://tspot.net'
// export const SERVER_BASE_URL = 'http://localhost:8000'
// export const CLIENT_BASE_URL = 'http://localhost:8000'
// export const SERVER_BASE_URL = "http://festadocinemaitaliano.test/admin";
// export const CLIENT_BASE_URL = "http://festadocinemaitaliano.test";
export const SERVER_BASE_URL = "https://festadocinemaitaliano.com/admin";
export const CLIENT_BASE_URL = "https://festadocinemaitaliano.com";
// export const SERVER_BASE_URL = 'http://festadocinemaitaliano.com.br/admin'
// export const CLIENT_BASE_URL = 'http://festadocinemaitaliano.com.br'

export const INVALIDATE_CITY = "INVALIDATE_CITY";
export const REQUEST_CITY = "REQUEST_CITY";
export const RECEIVE_CITY = "RECEIVE_CITY";
export const SELECT_DAY = "SELECT_DAY";
export const RECEIVE_MOVIES_FROM_SELECT_DAY = "RECEIVE_MOVIES_FROM_SELECT_DAY";
export const REQUEST_MENUS = "REQUEST_MENUS";
export const RECEIVE_MENUS = "RECEIVE_MENUS";
export const SELECT_MOVIE = "SELECT_MOVIE";
export const REQUEST_MOVIE = "REQUEST_MOVIE";
export const RECEIVE_MOVIE = "RECEIVE_MOVIE";
export const INVALIDATE_MOVIE = "INVALIDATE_MOVIE";
export const SELECT_PLAY_VIDEO = "SELECT_PLAY_VIDEO";
export const SELECT_CUSTOM_PAGE = "SELECT_CUSTOM_PAGE";
export const REQUEST_CUSTOM_PAGE = "REQUEST_CUSTOM_PAGE";
export const RECEIVE_CUSTOM_PAGE = "RECEIVE_CUSTOM_PAGE";
export const INVALIDATE_CUSTOM_PAGE = "INVALIDATE_CUSTOM_PAGE";
export const SELECT_ACTIVITY = "SELECT_ACTIVITY";
export const REQUEST_ACTIVITY = "REQUEST_ACTIVITY";
export const RECEIVE_ACTIVITY = "RECEIVE_ACTIVITY";
export const INVALIDATE_ACTIVITY = "INVALIDATE_ACTIVITY";
export const SELECT_QUERY = "SELECT_QUERY";
export const REQUEST_QUERY = "REQUEST_QUERY";
export const RECEIVE_QUERY_RESULTS = "RECEIVE_QUERY_RESULTS";
export const INVALIDATE_QUERY = "INVALIDATE_QUERY";
export const REQUEST_FEST_HISTORY = "REQUEST_FEST_HISTORY";
export const RECEIVE_FEST_HISTORY = "RECEIVE_FEST_HISTORY";
export const INVALIDATE_FEST_HISTORY = "INVALIDATE_FEST_HISTORY";
export const SELECT_HISTORY = "SELECT_HISTORY";
export const SELECT_FEST_HISTORY = "SELECT_FEST_HISTORY";
export const SELECT_SECTION = "SELECT_SECTION";
export const REQUEST_SECTIONS = "REQUEST_SECTIONS";
export const RECEIVE_SECTIONS = "RECEIVE_SECTIONS";
export const INVALIDATE_SECTIONS = "INVALIDATE_SECTIONS";
export const SELECT_MOV_2_FILTER = "SELECT_MOV_2_FILTER";
export const REQUEST_MOV_2_FILTER = "REQUEST_MOV_2_FILTER";
export const RECEIVE_MOV_2_FILTER = "RECEIVE_MOV_2_FILTER";
export const INVALIDATE_MOV_2_FILTER = "INVALIDATE_MOV_2_FILTER";
export const SELECT_AZ = "SELECT_AZ";
export const REQUEST_ACTIVITIES = "REQUEST_ACTIVITIES";
export const RECEIVE_ACTIVITIES = "RECEIVE_ACTIVITIES";
export const INVALIDATE_ACTIVITIES = "INVALIDATE_ACTIVITIES";
export const SELECT_PRESS_TYPE = "SELECT_PRESS_TYPE";
export const REQUEST_PRESS = "REQUEST_PRESS";
export const RECEIVE_PRESS = "RECEIVE_PRESS";
export const INVALIDATE_PRESS = "INVALIDATE_PRESS";
export const SELECT_SPONSOR_MENU = "SELECT_SPONSOR_MENU";
export const REQUEST_SPONSOR_MENU = "REQUEST_SPONSOR_MENU";
export const RECEIVE_SPONSOR_MENU = "RECEIVE_SPONSOR_MENU";
export const INVALIDATE_SPONSOR_MENU = "INVALIDATE_SPONSOR_MENU";
export const SELECT_SPONSOR_HOME = "SELECT_SPONSOR_HOME";
export const REQUEST_SPONSOR_HOME = "REQUEST_SPONSOR_HOME";
export const RECEIVE_SPONSOR_HOME = "RECEIVE_SPONSOR_HOME";
export const INVALIDATE_SPONSOR_HOME = "INVALIDATE_SPONSOR_HOME";
export const SELECT_POSTER = "SELECT_POSTER";
export const REQUEST_POSTER = "REQUEST_POSTER";
export const RECEIVE_POSTER = "RECEIVE_POSTER";
export const INVALIDATE_POSTER = "INVALIDATE_POSTER";
export const SELECT_NEWS_DETAIL = "SELECT_NEWS_DETAIL";
export const REQUEST_NEWS_DETAIL = "REQUEST_NEWS_DETAIL";
export const RECEIVE_NEWS_DETAIL = "RECEIVE_NEWS_DETAIL";
export const INVALIDATE_NEWS_DETAIL = "INVALIDATE_NEWS_DETAIL";
export const REQUEST_TICKET = "REQUEST_TICKET";
export const RECEIVE_TICKET = "RECEIVE_TICKET";
export const SELECT_FEST_PROG = "SELECT_FEST_PROG";
export const REQUEST_FEST_PROG = "REQUEST_FEST_PROG";
export const RECEIVE_FEST_PROG = "RECEIVE_FEST_PROG";
export const INVALIDATE_FEST_PROG = "INVALIDATE_FEST_PROG";
export const SELECT_SCOPE = "SELECT_SCOPE";
export const SELECT_AGENDACOLOR = "SELECT_AGENDACOLOR";
export const SELECT_VISIBILITY = "SELECT_VISIBILITY";
export const INVALIDATE_MENUS = "INVALIDATE_MENUS";
export const REQUEST_NEWSLETTER = "REQUEST_NEWSLETTER";
export const RECEIVE_NEWSLETTER_ACK = "RECEIVE_NEWSLETTER_ACK";
export const SET_NEWSLETTER_STATUS = "SET_NEWSLETTER_STATUS";

export const months = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro"
};

export function setShowNewsLetterForm(sended) {
  return {
    type: SET_NEWSLETTER_STATUS,
    sended
  };
}

export function selectScope(scope) {
  return {
    type: SELECT_SCOPE,
    scope
  };
}

export function selectAgendaColor(agenda_color) {
  return {
    type: SELECT_AGENDACOLOR,
    agenda_color
  };
}

export function selectCategory(category) {
  return {
    type: SELECT_CATEGORY,
    category
  };
}

export function invalidateCategory(category) {
  return {
    type: INVALIDATE_CATEGORY,
    category
  };
}

export function selectYear(year) {
  return {
    type: SELECT_YEAR,
    year
  };
}

export function selectCity(city = "-1") {
  return {
    type: SELECT_FESTIVAL_CITY,
    city
  };
}

export function selectDay(day) {
  return {
    type: SELECT_DAY,
    day
  };
}

export function selectMovie(movie_id) {
  return {
    type: SELECT_MOVIE,
    movie_id
  };
}

export function selectActivity(activity_id) {
  return {
    type: SELECT_ACTIVITY,
    activity_id
  };
}

export function selectQuery(query) {
  return {
    type: SELECT_QUERY,
    query
  };
}

export function selectPlayVideo(video_id) {
  return {
    type: SELECT_PLAY_VIDEO,
    video_id
  };
}

export function selectCustomPage(page) {
  return {
    type: SELECT_CUSTOM_PAGE,
    page
  };
}

export function selectFestHistory(section) {
  return {
    type: SELECT_HISTORY,
    section
  };
}

export function selectFestHistorySubPage(section) {
  return {
    type: SELECT_FEST_HISTORY,
    section
  };
}

export function selectSection(section_name, scope) {
  return {
    type: SELECT_SECTION,
    section_name,
    scope
  };
}

export function selectMov2Filter(mov_id, mov_name) {
  return {
    type: SELECT_MOV_2_FILTER,
    mov_id,
    mov_name
  };
}

export function selectAZ(orderstate) {
  return {
    type: SELECT_AZ,
    orderstate
  };
}

export function selectPressType(press_type) {
  return {
    type: SELECT_PRESS_TYPE,
    press_type
  };
}

export function selectSponsorMenu(sponsor_id) {
  return {
    type: SELECT_SPONSOR_MENU,
    sponsor_id
  };
}

export function selectSponsorHome() {
  return {
    type: SELECT_SPONSOR_HOME
  };
}

export function selectPoster() {
  return {
    type: SELECT_POSTER
  };
}

export function selectNewsDetails(news_id) {
  return {
    type: SELECT_NEWS_DETAIL,
    news_id
  };
}

export function selectFestProg() {
  return {
    type: SELECT_FEST_PROG
  };
}

export function receiveMoviesFromSelectedDay(movies) {
  return {
    type: RECEIVE_MOVIES_FROM_SELECT_DAY,
    movies
  };
}

export function invalidateFestivalCity(city) {
  return {
    type: INVALIDATE_FESTIVAL_CITY,
    city
  };
}

function requestMovies(category, scope) {
  return {
    type: REQUEST_MOVIES,
    category,
    scope
  };
}

function requestNews(scope) {
  return {
    type: REQUEST_NEWS,
    scope
  };
}

function requestMoviesFromCity(city) {
  return {
    type: REQUEST_FESTIVAL_CITY,
    city
  };
}

function requestCities() {
  return {
    type: REQUEST_CITY
  };
}

function requestMenus(scope) {
  return {
    type: REQUEST_MENUS,
    scope
  };
}

function requestMovie(movie_id) {
  return {
    type: REQUEST_MOVIE,
    movie_id
  };
}

function requestActivity(activity_id) {
  return {
    type: REQUEST_ACTIVITY,
    activity_id
  };
}

function requestQuery(query) {
  return {
    type: REQUEST_QUERY,
    query
  };
}

function requestCustomPage(page) {
  return {
    type: REQUEST_CUSTOM_PAGE,
    page
  };
}

function requestFestHistory(edition) {
  return {
    type: REQUEST_FEST_HISTORY,
    edition
  };
}

function requestSections(assetType, scope) {
  return {
    type: REQUEST_SECTIONS,
    assetType,
    scope
  };
}

function requestMov2Filter() {
  return {
    type: REQUEST_MOV_2_FILTER
  };
}

function requestActivities() {
  return {
    type: REQUEST_ACTIVITIES
  };
}

function requestPress(press_type) {
  return {
    type: REQUEST_PRESS,
    press_type
  };
}

function requestSponsorMenu(sponsor_id, scope) {
  return {
    type: REQUEST_SPONSOR_MENU,
    sponsor_id,
    scope
  };
}

function requestSponsorHome() {
  return {
    type: REQUEST_SPONSOR_HOME
  };
}

function requestPoster(scope) {
  return {
    type: REQUEST_POSTER,
    scope
  };
}

function requestNewsDetails(news_id) {
  return {
    type: REQUEST_NEWS_DETAIL,
    news_id
  };
}

function requestTicket(req) {
  return {
    type: REQUEST_TICKET,
    req
  };
}

function requestNewsletter(req) {
  return {
    type: REQUEST_NEWSLETTER,
    req
  };
}

function requestFestProg() {
  return {
    type: REQUEST_FEST_PROG
  };
}

function receiveMovies(category, scope, json) {
  return {
    type: RECEIVE_MOVIES,
    category,
    // movies: json.data.children.map((child) => child.data),
    movies: json,
    scope,
    receivedAt: Date.now()
  };
}

function receiveMoviesByIds(movies) {
  return {
    type: RECEIVE_MOVIES_BY_IDS,
    movies,
    receivedAt: Date.now()
  };
}

function receiveNews(scope, json) {
  return {
    type: RECEIVE_NEWS,
    isFetchingNews: false,
    didInvalidate: false,
    news: json,
    scope,
    receivedAt: Date.now()
  };
}

function receiveMoviesFromCity(city, json) {
  /*
  if (Array.isArray(json)) {
    json = {};
  }
  */
  const festivals = Array.isArray(json.festivals) ? {} : json.festivals;
  const numPastEvents =
    typeof json.numPastEvents === "undefined" ? 0 : json.numPastEvents;

  return {
    type: RECEIVE_FESTIVAL_CITY,
    city,
    movies: festivals,
    numPastEvents: numPastEvents,
    receivedAt: Date.now()
  };
}

function receiveCities(json) {
  return {
    type: RECEIVE_CITY,
    cities: json,
    receivedAt: Date.now()
  };
}

function receiveMenus(json, scope) {
  return {
    type: RECEIVE_MENUS,
    menus: json,
    scope,
    receivedAt: Date.now()
  };
}

function receiveMovie(movie_id, json) {
  return {
    type: RECEIVE_MOVIE,
    movie_id,
    details: json,
    receivedAt: Date.now()
  };
}

function receiveActivity(activity_id, json) {
  return {
    type: RECEIVE_ACTIVITY,
    activity_id,
    details: json,
    receivedAt: Date.now()
  };
}

function receiveQueryResults(query, json) {
  return {
    type: RECEIVE_QUERY_RESULTS,
    query,
    results: json,
    receivedAt: Date.now()
  };
}

function receiveCustomPage(page, json) {
  return {
    type: RECEIVE_CUSTOM_PAGE,
    page,
    details: json,
    receivedAt: Date.now()
  };
}

function receiveFestHistory(edition, json) {
  return {
    type: RECEIVE_FEST_HISTORY,
    isFetchingNews: false,
    didInvalidate: false,
    edition,
    fest: json,
    receivedAt: Date.now()
  };
}

function receiveSections(json, assetType, scope) {
  return {
    type: RECEIVE_SECTIONS,
    isFetchingSections: false,
    didInvalidateSections: false,
    sections: json,
    assetType,
    scope,
    receivedAt: Date.now()
  };
}

function receiveMovs2filter(json) {
  return {
    type: RECEIVE_MOV_2_FILTER,
    isFetchingMov2Filter: false,
    didInvalidateMov2Filter: false,
    movs: json,
    receivedAt: Date.now()
  };
}

function receiveActivities(json) {
  return {
    type: RECEIVE_ACTIVITIES,
    isFetchingNews: false,
    didInvalidate: false,
    activities: json,
    receivedAt: Date.now()
  };
}

function receivePress(press_type, json) {
  return {
    type: RECEIVE_PRESS,
    isFetchingNews: false,
    didInvalidate: false,
    press_type,
    press: json,
    receivedAt: Date.now()
  };
}

function receiveSponsorMenu(sponsor_id, json, scope) {
  return {
    type: RECEIVE_SPONSOR_MENU,
    isFetchingNews: false,
    didInvalidate: false,
    sponsor_id,
    sponsor: json,
    scope,
    receivedAt: Date.now()
  };
}

function receiveSponsorHome(json) {
  return {
    type: RECEIVE_SPONSOR_HOME,
    isFetchingNews: false,
    didInvalidate: false,
    sponsors: json,
    receivedAt: Date.now()
  };
}

function receivePoster(json, scope = "festa") {
  return {
    type: RECEIVE_POSTER,
    isFetchingPosters: false,
    didInvalidatePosters: false,
    posters: json,
    scope,
    receivedAt: Date.now()
  };
}

function receiveNewsDetails(news_id, json) {
  return {
    type: RECEIVE_NEWS_DETAIL,
    news_id,
    details: json,
    receivedAt: Date.now()
  };
}

function receiveTicket(json) {
  return {
    type: RECEIVE_TICKET,
    resp: json,
    receivedAt: Date.now()
  };
}

function receiveNewsletterAck(json) {
  return {
    type: RECEIVE_NEWSLETTER_ACK,
    resp: json,
    receivedAt: Date.now()
  };
}

function receiveFestProg(json) {
  return {
    type: RECEIVE_FEST_PROG,
    festprogram: json,
    receivedAt: Date.now()
  };
}

export function fetchMovies(category, scope) {
  return dispatch => {
    dispatch(requestMovies(category, scope));
    return fetch(
      `${SERVER_BASE_URL}/api/movies_from_categ/${category}/${scope}`
    )
      .then(req => req.json())
      .then(json => {
        dispatch(receiveMovies(category, scope, json));
      });
  };
}

function fetchNews(scope) {
  return dispatch => {
    dispatch(requestNews(scope));
    return fetch(`${SERVER_BASE_URL}/api/news/${scope}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveNews(scope, json));
      });
  };
}

function fetchMoviesFromFestivalCity(city) {
  return dispatch => {
    dispatch(requestMoviesFromCity(city));
    return fetch(`${SERVER_BASE_URL}/api/movies_from_festival/${city}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveMoviesFromCity(city, json));
      });
  };
}

function fetchCities() {
  return dispatch => {
    dispatch(requestCities());
    return fetch(`${SERVER_BASE_URL}/api/cities`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveCities(json));
      });
  };
}

function fetchMenus(scope) {
  return dispatch => {
    dispatch(requestMenus(scope));
    // return fetch(`${SERVER_BASE_URL}/api/menus`)
    return fetch(`${SERVER_BASE_URL}/api/menus/${scope}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveMenus(json, scope));
      });
  };
}

function fetchMovie(movie_id) {
  return dispatch => {
    dispatch(requestMovie(movie_id));
    return fetch(`${SERVER_BASE_URL}/api/movie/${movie_id}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveMovie(movie_id, json));
      });
  };
}

function fetchActivity(activity_id) {
  return dispatch => {
    dispatch(requestActivity(activity_id));
    return fetch(`${SERVER_BASE_URL}/api/activity/${activity_id}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveActivity(activity_id, json));
      });
  };
}

function fetchQuery(query) {
  return dispatch => {
    dispatch(requestQuery(query));
    return fetch(`${SERVER_BASE_URL}/api/search?q=${query}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveQueryResults(query, json));
      });
  };
}

function fetchCustomPage(page) {
  return dispatch => {
    if (page[page.length - 1] === "/") {
      page = page.slice(0, -1);
    }

    dispatch(requestCustomPage(page));
    return fetch(`${SERVER_BASE_URL}/api/custompage/${page}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveCustomPage(page, json));
      });
  };
}

function fetchFestHistory(edition) {
  return dispatch => {
    dispatch(requestFestHistory(edition));
    return fetch(`${SERVER_BASE_URL}/api/festival_history/${edition}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveFestHistory(edition, json));
      });
  };
}

function fetchSections(assetType, scope) {
  return dispatch => {
    dispatch(requestSections(assetType, scope));
    return fetch(`${SERVER_BASE_URL}/api/sections/${assetType}/${scope}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveSections(json, assetType, scope));
      });
  };
}

function fetchMovs2Filter() {
  return dispatch => {
    dispatch(requestMov2Filter());
    return fetch(`${SERVER_BASE_URL}/api/movies2filter`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveMovs2filter(json));
      });
  };
}

function fetchActivities() {
  return dispatch => {
    dispatch(requestActivities());
    return fetch(`${SERVER_BASE_URL}/api/activities`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveActivities(json));
      });
  };
}

function fetchPress(pressType) {
  return dispatch => {
    dispatch(requestPress());
    return fetch(`${SERVER_BASE_URL}/api/press/${pressType}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receivePress(pressType, json));
      });
  };
}

function fetchSponsorMenu(sponsor_id, scope = "festa") {
  return dispatch => {
    dispatch(requestSponsorMenu(sponsor_id, scope));
    return fetch(
      `${SERVER_BASE_URL}/api/sponsors_from_menu/${sponsor_id}/${scope}`
    )
      .then(req => req.json())
      .then(json => {
        dispatch(receiveSponsorMenu(sponsor_id, json, scope));
      });
  };
}

function fetchSponsorHome() {
  return dispatch => {
    dispatch(requestSponsorHome());
    return fetch(`${SERVER_BASE_URL}/api/sponsors_from_home`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveSponsorHome(json));
      });
  };
}

function fetchNewsDetails(news_id) {
  return dispatch => {
    dispatch(requestNewsDetails(news_id));
    return fetch(`${SERVER_BASE_URL}/api/news/${news_id}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveNewsDetails(news_id, json));
      });
  };
}

function fetchPoster(scope = "festa") {
  return dispatch => {
    dispatch(requestPoster(scope));
    return fetch(`${SERVER_BASE_URL}/api/posters/${scope}`)
      .then(req => req.json())
      .then(json => {
        dispatch(receivePoster(json, scope));
      });
  };
}

function fetchFestProg() {
  return dispatch => {
    dispatch(requestFestProg());
    return fetch(`${SERVER_BASE_URL}/api/festival_program`)
      .then(req => req.json())
      .then(json => {
        dispatch(receiveFestProg(json));
      });
  };
}

function shouldFetchMovies(state, category, scope) {
  const currentScope = state.selectedScope;
  if (currentScope !== scope) {
    return true;
  }

  const movies = state.moviesByCategory[category];
  if (!movies) {
    return true;
  } else if (movies.isFetching) {
    return false;
  } else {
    return movies.didInvalidate;
  }
}

function shouldFetchNews(state, scope = "festa") {
  const currentScope = state.selectedScope;
  if (currentScope !== scope) {
    return true;
  }

  const news = state.getAllnews["news"];
  if (!news) {
    return true;
  } else if (news.isFetching) {
    return false;
  } else {
    return news.didInvalidate;
  }
}

function shouldFetchMoviesFromFestival(state, city) {
  const movies = state.getMoviesFromFestival[city];
  if (!movies) {
    return true;
  } else if (movies.isFetching) {
    return false;
  } else {
    return movies.didInvalidate;
  }
}

function shouldFetchCities(state) {
  const cities = state.getAllCities["all"];
  if (!cities) {
    return true;
  } else if (cities.isFetching) {
    return false;
  } else {
    return cities.didInvalidate;
  }
}

function shouldFetchMenus(state, scope) {
  // const menus = state.getMenus['all']
  const menus = state.getMenus[scope];
  if (!menus) {
    return true;
  } else if (menus.isFetchingMenus) {
    return false;
  } else {
    return menus.didInvalidateMenus;
  }
}

function shouldFetchMovie(state, movie_id) {
  const details = state.getMovieDetails[movie_id];
  if (!details) {
    return true;
  } else if (details.isFetchingMDetail) {
    return false;
  } else {
    return details.didInvalidateMDetail;
  }
}

function shouldFetchActivity(state, activity_id) {
  const details = state.getActivityDetails[activity_id];
  if (!details) {
    return true;
  } else if (details.isFetchingADetail) {
    return false;
  } else {
    return details.didInvalidateADetail;
  }
}

function shouldFetchQuery(state, query) {
  const results = state.getSearchResults[query];
  if (!results) {
    return true;
  } else if (results.isFetchingSearch) {
    return false;
  } else {
    return results.didInvalidateSearch;
  }
}

function shouldFetchCustomPage(state, page) {
  const details = state.getCustomPage[page];
  if (!details) {
    return true;
  } else if (details.isFetchingCPage) {
    return false;
  } else {
    return details.didInvalidateCPage;
  }
}

function shouldFetchFestHistory(state, section) {
  const fest = state.getFestHistory[section];
  if (!fest) {
    return true;
  } else if (fest.isFetchingFestHistory) {
    return false;
  } else {
    return fest.didInvalidateFestHistory;
  }
}

function shouldFetchSections(state, assetType, scope) {
  const sections = state.getSections[`${assetType}_${scope}`];
  if (!sections) {
    return true;
  } else if (sections.isFetchingSectionsSections) {
    return false;
  } else {
    return sections.didInvalidateSections;
  }
}

function shouldFetchMovs2Filter(state) {
  const movs2filter = state.getMovs2Filter["all"];
  if (!movs2filter) {
    return true;
  } else if (movs2filter.isFetchingMov2Filter) {
    return false;
  } else {
    return movs2filter.didInvalidateMov2Filter;
  }
}

function shouldFetchActivities(state) {
  const activities = state.getActivities["all"];
  if (!activities) {
    return true;
  } else if (activities.isFetchingActivities) {
    return false;
  } else {
    return activities.didInvalidateActivities;
  }
}

function shouldFetchPress(state, press_type) {
  const press = state.getPress[press_type];
  if (!press) {
    return true;
  } else if (press.isFetchingPress) {
    return false;
  } else {
    return press.didInvalidatePress;
  }
}

function shouldFetchSponsorMenu(state, sponsor_id, scope) {
  const sfrommenu = state.getSponsorMenu[`${scope}_${sponsor_id}`];
  if (!sfrommenu) {
    return true;
  } else if (sfrommenu.isFetchingSpMenu) {
    return false;
  } else {
    return sfrommenu.didInvalidateSpMenu;
  }
}

function shouldFetchSponsorHome(state) {
  const sfromhome = state.getSponsorHome["all"];
  if (!sfromhome) {
    return true;
  } else if (sfromhome.isFetchingsSpHome) {
    return false;
  } else {
    return sfromhome.didInvalidateSpHome;
  }
}

function shouldFetchPoster(state, scope) {
  const p = state.getPosters[scope];
  if (!p) {
    return true;
  } else if (p.isFetchingPosters) {
    return false;
  } else {
    return p.didInvalidatePosters;
  }
}

function shouldFetchNewsDetails(state, news_id) {
  const details = state.getNewsDetails[news_id];
  if (!details) {
    return true;
  } else if (details.isFetchingNDetail) {
    return false;
  } else {
    return details.didInvalidateNDetail;
  }
}

function shouldFetchFestProg(state) {
  const p = state.getFestProg["all"];
  if (!p) {
    return true;
  } else if (p.isFetchingFestProg) {
    return false;
  } else {
    return p.didInvalidateFestProg;
  }
}

export function fetchMoviesIfNeeded(category, scope = "festa", forced = false) {
  return (dispatch, getState) => {
    if (forced) {
      return dispatch(fetchMovies(category, scope));
    }
    if (shouldFetchMovies(getState(), category, scope)) {
      return dispatch(fetchMovies(category, scope));
    }
  };
}

export function fetchNewsIfNeeded(scope = "festa") {
  return (dispatch, getState) => {
    if (shouldFetchNews(getState(), scope)) {
      return dispatch(fetchNews(scope));
    }
  };
}

export function fetchMoviesFromFestivalIfNeeded(city = "-1") {
  return (dispatch, getState) => {
    if (shouldFetchMoviesFromFestival(getState(), city)) {
      return dispatch(fetchMoviesFromFestivalCity(city));
    } else {
      return getState().getMoviesFromFestival[city].items;
    }
  };
}

export function fetchCitiesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchCities(getState())) {
      return dispatch(fetchCities());
    }
  };
}

export function fetchMenusIfNeeded(scope = "festa") {
  return (dispatch, getState) => {
    if (shouldFetchMenus(getState(), scope)) {
      return dispatch(fetchMenus(scope));
    }
  };
}

export function fetchMovieDetailsIfNeeded(movie_id) {
  return (dispatch, getState) => {
    if (shouldFetchMovie(getState(), movie_id)) {
      return dispatch(fetchMovie(movie_id));
    }
  };
}

export function fetchActivityIfNeeded(activity_id) {
  return (dispatch, getState) => {
    if (shouldFetchActivity(getState(), activity_id)) {
      return dispatch(fetchActivity(activity_id));
    }
  };
}

export function fetchCustomPageIfNeeded(page) {
  return (dispatch, getState) => {
    if (shouldFetchCustomPage(getState(), page)) {
      return dispatch(fetchCustomPage(page));
    }
  };
}

export function fetchSearchIfNeeded(query) {
  return (dispatch, getState) => {
    if (shouldFetchQuery(getState(), query)) {
      return dispatch(fetchQuery(query));
    }
  };
}

export function fetchFestHistoryIfNeeded(section) {
  return (dispatch, getState) => {
    if (shouldFetchFestHistory(getState(), section)) {
      return dispatch(fetchFestHistory(section));
    }
  };
}

export function fetchActivitiesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchActivities(getState())) {
      return dispatch(fetchActivities());
    }
  };
}

export function getMovieLiteFromIds(ids) {
  return (dispatch, getState) => {
    const s = getState();
    const all_movies = s.moviesById;
    const l = ids.map(id => {
      return all_movies[s.selectedCategory][id];
    });
    return dispatch(receiveMoviesByIds(l));
  };
}

export function fetchMoviesFromFestivalDay() {
  return (dispatch, getState) => {
    const s = getState();
    return s.getMoviesFromFestival[s.selectedCity][s.selectedDay];
  };
}

export function fetchSectionsIfNeeded(assetType = "all", scope = "festa") {
  return (dispatch, getState) => {
    if (shouldFetchSections(getState(), assetType, scope)) {
      return dispatch(fetchSections(assetType, scope));
    }
  };
}

export function fetchMovs2FilterIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchMovs2Filter(getState())) {
      return dispatch(fetchMovs2Filter());
    }
  };
}

export function fetchPressIfNeeded(press_type) {
  return (dispatch, getState) => {
    if (shouldFetchPress(getState(), press_type)) {
      return dispatch(fetchPress(press_type));
    }
  };
}

export function fetchSponsorMenuIfNeeded(sponsor_id, scope = "festa") {
  return (dispatch, getState) => {
    if (shouldFetchSponsorMenu(getState(), sponsor_id, scope)) {
      return dispatch(fetchSponsorMenu(sponsor_id, scope));
    }
  };
}

export function fetchSponsorHomeIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchSponsorHome(getState())) {
      return dispatch(fetchSponsorHome());
    }
  };
}

export function fetchPosterIfNeeded(scope = "festa") {
  return (dispatch, getState) => {
    if (shouldFetchPoster(getState(), scope)) {
      return dispatch(fetchPoster(scope));
    }
  };
}

export function fetchNewsDetailsIfNeeded(news_id) {
  return (dispatch, getState) => {
    if (shouldFetchNewsDetails(getState(), news_id)) {
      return dispatch(fetchNewsDetails(news_id));
    }
  };
}

export function fetchFestProgIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchFestProg(getState())) {
      return dispatch(fetchFestProg());
    }
  };
}

export function storeTicketRequest(data) {
  return dispatch => {
    dispatch(requestTicket(data));
    return fetch(`${SERVER_BASE_URL}/api/ticket`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then(req => req.json())
      .then(json => {
        dispatch(receiveTicket(json));
      });
  };
}

export function sendNewletterRequest(data) {
  return dispatch => {
    dispatch(requestNewsletter(data));
    return fetch(`${SERVER_BASE_URL}/api/newsletter`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then(req => req.json())
      .then(json => {
        dispatch(setShowNewsLetterForm(false));
        dispatch(receiveNewsletterAck(json));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js